<template>
  <div>
    <b-modal v-model="show" ref="modal-rrhh-administrative-payroll" :title="$t('PAYROLL APPROVE') + ': ' + payroll.name"
      modal-class="modal-primary" @hidden="$emit('hideModal')" size="xl" no-close-on-backdrop no-close-on-esc scrollable
      title-class="h6" :body-class="'px-0 overflow-x-hidden'">
      <!-- <div class="scroll-kanban p-75"> -->
      <div class="view-toggle-bar">
        <div class="toggle-info">
          <span class="toggle-title">Vista de aprobación</span>
          <span class="toggle-hint">Prueba el nuevo diseño y decide si lo mantenemos</span>
        </div>
        <div class="segmented-control">
          <button type="button" :class="['seg-btn', { active: viewMode === 'current' }]" @click="viewMode = 'current'">
            Vista actual
          </button>
          <button type="button" :class="['seg-btn', { active: viewMode === 'beta' }]" @click="viewMode = 'beta'">
            Nuevo diseño <span class="beta-pill">BETA</span>
          </button>
        </div>
      </div>

      <b-row class="p-2" v-if="viewMode === 'current'">
        <b-col xl="4">
          <b-card class="card-app-design mb-1" body-class="py-1">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <h6 class="luxury-gradient-text d-flex align-items-center mb-0">
                <feather-icon icon="CalendarIcon" size="18" class="mr-50" /> ASISTENCIAS
              </h6>
              <b-button v-if="payroll.apply_attendance == 1" variant="primary" size="sm" v-b-tooltip.hover.v-primary
                title="Ver Horario">
                <feather-icon @click="viewSchedule(employeeId)" icon="ClockIcon" class="cursor-pointer" size="16" />
              </b-button>
            </div>
            <div class="scroll-kanban mt-1" style="overflow-x: hidden; height: 50vh !important;" v-if="payroll.apply_attendance == 1">
              <div class="day mt-1" v-for="(attendance, index) in getAttendances" :key="index">
                <b-badge variant="light-secondary" class="my-badge" style="padding: 0.5rem">
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="d-flex">
                      <feather-icon icon="CalendarIcon" class="text-primary" style="margin-right: 5px" />
                      <span class="day-font">
                        {{ attendance.date | prettyDateWithoutTime }}
                      </span>
                      <span class="text-primary ml-1 py-25 px-50 rounded" style="border: 1px solid #0090e7">{{
                        resolveFieldDay(attendance.date) }}</span>
                    </div>

                    <div class="d-flex px-1">
                      <feather-icon v-if="attendance.new_status == 5" icon="EditIcon"
                        class="text-primary cursor-pointer mr-50" size="16" @click="
                          openModalJustificationAttendance(attendance, 'single')
                          " />

                      <feather-icon v-if="
                        attendance.end == null && attendance.new_status == 5
                      " icon="CheckIcon" v-b-tooltip.hover.bottom="$t('Create Manual Attendance')
                        " class="text-success cursor-pointer" size="16"
                        @click="openCreateManualAttendanceModal(attendance)" />
                    </div>
                  </div>

                  <div class="d-flex">
                    <div class="d-inline-block justify-content-center w-100 px-3 py-2"
                      v-if="attendance.new_status == 2">
                      <b-badge class="d-inline-block" variant="light-info">Dia no laborable</b-badge>
                    </div>

                    <div class="d-flex flex-column justify-content-center w-100 px-3 py-2"
                      v-else-if="attendance.es_vacacion == 1">
                      <b-badge variant="light-success">Vacaciones</b-badge>
                    </div>

                    <div class="d-flex flex-column justify-content-center w-100 px-3 py-2"
                      v-else-if="attendance.is_holiday == 1">
                      <b-badge variant="light-danger">Feriado</b-badge>
                    </div>

                    <div v-else class="d-flex-column">
                      <div style="margin-top: 10px" class="d-flex justify-content-start align-items-center">
                        <span class="text-right" style="width: 80px">Entrada:
                        </span>
                        <b-badge class="ml-1 text-center" :variant="attendance.start != null
                          ? attendance.is_late == 1
                            ? 'light-warning'
                            : 'light-success'
                          : 'light-danger'
                          ">
                          {{
                            attendance.start != null
                              ? attendance.start
                              : $t("Not Mark")
                          }}
                        </b-badge>
                        <feather-icon v-if="attendance.start !== null" icon="ClockIcon" :class="{
                          'text-success': attendance.is_late == 0,
                          'text-warning': attendance.is_late == 1,
                        }" style="margin-left: 5px" />
                      </div>

                      <div style="margin-top: 6px" class="d-flex justify-content-start align-items-center">
                        <span class="text-right" style="width: 80px">Salida:
                        </span>
                        <b-badge class="ml-1 text-center" :variant="attendance.end != null
                          ? 'light-success'
                          : 'light-danger'
                          ">
                          {{
                            attendance.end != null
                              ? attendance.end
                              : $t("Not Mark")
                          }}
                        </b-badge>
                        <feather-icon v-if="attendance.end !== null" icon="ClockIcon" class="text-success"
                          style="margin-left: 5px" />
                      </div>
                    </div>
                    <div v-if="[6, 7, 8].includes(attendance.new_status)"
                      class="d-flex align-items-center justify-content-end w-100">
                      <span class="cursor-pointer text-right" @click="openShowJustificationModal(attendance)">
                        <b-avatar v-if="attendance.new_status == 6" rounded variant="light-primary"
                          v-b-tooltip.hover.v-primary title="Justificado">
                          <feather-icon icon="CheckCircleIcon" size="25" />
                        </b-avatar>

                        <div v-if="attendance.has_justification">
                          <span v-if="attendance.justification.aplicar_descuento" class="d-block text-danger"
                            style="margin-top: 0.3rem; margin-bottom: 0.3rem">
                            Desc. por tardanza
                          </span>

                          <span style="margin-top: 0.5rem; max-width: 150px" v-if="attendance.justification.observation"
                            class="d-block text-truncate" v-b-tooltip.hover
                            :title="attendance.justification.observation">
                            {{ attendance.justification.observation }}
                          </span>
                        </div>

                        <b-avatar v-if="attendance.new_status == 7" rounded variant="light-danger"
                          v-b-tooltip.hover.v-danger title="Justificacion Rechazada">
                          <feather-icon icon="XCircleIcon" size="25" />
                        </b-avatar>

                        <b-avatar v-if="attendance.new_status == 8" rounded variant="light-warning"
                          v-b-tooltip.hover.v-warning title="Justificacion Pendiente">
                          <feather-icon icon="AlertTriangleIcon" size="25" />
                        </b-avatar>
                      </span>
                    </div>
                  </div>
                </b-badge>
              </div>
            </div>
            <div v-else class="scoll-kanban mt-1" style="height: 50vh !important;">
              <div class="day">
                <b-badge variant="light-warning" class="my-badge">
                  <div class="d-flex justify-content-center align-items-center w-100"
                    style="margin-top: 3px; height: 68px">
                    <span>El trabajador no marca asistencias</span>
                  </div>
                </b-badge>
              </div>
            </div>
          </b-card>

          <!-- RESUMEN DE ASISTENCIAS -->
          <b-card class="card-app-design mb-1 mt-1" body-class="py-0">
            <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
              <feather-icon icon="PieChartIcon" size="18" class="mr-50" /> RESUMEN DE ASISTENCIAS
            </h6>
            <div class="d-flex flex-column mt-1 mb-2 px-1">
              <div class="d-flex justify-content-between align-items-center pb-50 mb-50 border-bottom text-muted">
                 <span class="font-weight-bolder text-secondary">Total Días Computables:</span>
                 <b-badge variant="light-primary">{{ getAttendances.length }}</b-badge>
              </div>
              <div v-for="(item, index) in attendanceBreakdown" :key="index" class="d-flex justify-content-between align-items-center py-50 border-bottom">
                 <div class="d-flex align-items-center">
                    <feather-icon icon="CircleIcon" size="10" :class="item.variant.replace('light-', 'text-')" class="mr-50" />
                    <span class="font-weight-bolder text-capitalize" :class="item.variant.replace('light-', 'text-')">{{ item.name.toLowerCase() }}</span>
                 </div>
                 <b-badge :variant="item.variant">{{ item.count }}</b-badge>
              </div>
              <div class="d-flex justify-content-between align-items-center pt-50">
                 <span class="font-weight-bolder text-secondary text-info">Tardanzas (Sancionables):</span>
                 <b-badge variant="light-info">{{ parseInt(cantidad_tardanzas || 0) + parseInt(cantidad_tardanzas_mes || 0) }}</b-badge>
              </div>
            </div>
          </b-card>

        </b-col>

        <b-col xl="8">
          <b-row>
            <b-col md="12" class="mb-1">
              <b-card class="card-app-design mb-0" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="UserIcon" size="18" class="mr-50" /> INFORMACION GENERAL
                </h6>


                <div class="d-flex flex-column gap-y-3 mt-2">
                  <div class="d-flex gap-3">
                    <span class="text-primary">Area:</span>
                    <strong>{{ department }}</strong>
                  </div>

                  <div class="d-flex  justify-content-between">
                    <b-media no-body>
                      <b-media-aside class="mr-1">
                        <b-avatar rounded variant="light-primary" size="34">
                          <feather-icon icon="CalendarIcon" size="18" />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body>
                        <h6 class="mb-0">{{ start_date_work | myDateEs }}</h6>
                        <small> Inicio Laboral </small>
                      </b-media-body>
                    </b-media>

                    <div v-if="fecha_cese != null" class="d-flex align-items-center gap-3">
                      <b-avatar rounded variant="light-danger" size="34">
                        <feather-icon icon="CalendarIcon" size="18" />
                      </b-avatar>
                      <div class="d-flex flex-column" style="width: 100px;">
                        <h6 class="mb-0">{{ fecha_cese | myDateEs }}</h6>
                        <small> Fecha Cese </small>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between mt-2">
                    <b-media no-body>
                      <b-media-aside class="">
                        <b-avatar rounded variant="light-primary" size="34">
                          <feather-icon icon="CalendarIcon" size="18" />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body>
                        <h6 class="text-primary">
                          {{ cutOfDate | myGlobal }}
                        </h6>
                        <small> {{ $t("Cut of Date") }} </small>
                      </b-media-body>
                    </b-media>

                    <div class="d-flex align-items-center gap-3" v-if="payroll.payment_method == 'fornightly'">
                      <b-avatar rounded variant="light-primary" size="34">
                        S/.
                      </b-avatar>

                      <div class="d-flex flex-column" style="width: 100px">
                        <h6 class="mb-0">S/ {{ fortnightAmount }}</h6>
                        <p class="card-text mb-25 text-primary">
                          1era Quincena
                        </p>
                      </div>
                    </div>

                    <div v-if="isMonthly" class="d-flex align-items-center gap-3">
                      <b-avatar rounded variant="light-primary" size="34">
                        S/.
                      </b-avatar>
                      <div class="d-flex flex-column" style="width: 100px">
                        <h6 class="mb-0">S/ {{ monthlyAmount }}</h6>
                        <p class="card-text mb-25 text-primary">
                          {{ payroll.payment_method == 'fornightly' ? '2da Quincena' : 'Mensual' }}
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </b-card>
            </b-col>

            <!-- INFORMACION SALARIAL -->
            <b-col md="5">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="DollarSignIcon" size="18" class="mr-50" /> INFORMACION SALARIAL
                </h6>
                <div class="" style="height: 270px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> SUELDO BASE: </b-td>
                        <b-td class="text-primary">
                          S/. {{ basicSalary | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONIFICACION: </b-td>
                        <b-td class="text-primary">
                          S/. {{ bonification | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SALARIO DIARIO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salaryPerDay | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SUELDO AFECTO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salary_afecto | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SALARIO DIARIO AFECT.: </b-td>
                        <b-td class="text-primary">
                          S/. {{ salario_diario_afecto | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DOMINICAL: </b-td>
                        <b-td class="text-primary">
                          S/. {{ dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="2"></b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DIAS PAGADOS: </b-td>
                        <b-td class="text-primary"> {{ workedDays }} </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DIAS NO PAGADOS: </b-td>
                        <b-td class="text-danger"> {{ notWorkedDays }} </b-td>
                      </b-tr>

                      <b-tr>
                        <b-td colspan="2"></b-td>
                      </b-tr>
                      <template v-if="payroll.payment_method == 'fornightly'">
                        <b-tr>
                          <b-td> FALTAS 1ERA QUINCENA: </b-td>
                          <b-td class="text-danger"> {{ cantidad_faltas_quincena }} </b-td>
                        </b-tr>
                        <b-tr v-if="isMonthly">
                          <b-td> FALTAS 2DA QUINCENA: </b-td>
                          <b-td class="text-danger"> {{ cantidad_faltas_mes }} </b-td>
                        </b-tr>
                      </template>

                      <template v-if="payroll.payment_method == 'fornightly'">
                        <b-tr>
                          <b-td colspan="2"></b-td>
                        </b-tr>

                        <b-tr>
                          <b-td> TARDANZAS 1ERA QUINCENA: </b-td>
                          <b-td class="text-danger"> {{ cantidad_tardanzas }} </b-td>
                        </b-tr>
                        <b-tr v-if="isMonthly">
                          <b-td> TARDANZAS 2DA QUINCENA: </b-td>
                          <b-td class="text-danger"> {{ cantidad_tardanzas_mes }} </b-td>
                        </b-tr>
                      </template>
                      <template v-else>
                        <b-tr>
                          <b-td> TARDANZAS: </b-td>
                          <b-td class="text-danger">
                            {{ cantidad_tardanzas }}
                          </b-td>
                        </b-tr>
                      </template>
                      <b-tr>
                        <b-td>TRABAJO ADICIONAL: </b-td>
                        <b-td class="text-primary">
                          {{ cantidad_trabajo_adicional }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- RESUMEN DE DESCUENTOS -->
            <b-col md="7">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="TrendingDownIcon" size="18" class="mr-50" /> RESUMEN DE DESCUENTOS Y ADICIONALES
                </h6>
                <div class="" style="height: 260px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> BONO 1RA QUINCENA: </b-td>
                        <b-td class="text-primary">
                          S/. +
                          {{ (bono_quincena) | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO 2DA QUINCENA: </b-td>
                        <b-td class="text-primary">
                          S/. +
                          {{ (bono_mensual) | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TRABAJO ADICIONAL: </b-td>
                        <b-td class="text-primary">
                          S/. + {{ monto_trabajo_adicional | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> FALTAS: </b-td>
                        <b-td class="text-danger">
                          S/. - {{ descuento_falta | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TARDANZAS: </b-td>
                        <b-td class="text-danger">
                          S/. - {{ descuento_tardanza | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DOMINICAL: </b-td>
                        <b-td class="text-danger">
                          S/. - {{ total_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr v-if="tipo_planilla == 'Form'">
                        <b-td> APORTES: </b-td>
                        <b-td class="text-danger">
                          S/. - {{ descuento_aportes | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr v-if="tipo_planilla == 'Form'">
                        <b-td> RET. QUINTA: </b-td>
                        <b-td class="text-danger">
                          S/. - {{ descuento_quinta | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> POR CONCEPTO: </b-td>
                        <b-td class="text-danger">
                          S/. - {{ descuento_por_concepto | currencyZero }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- DETALLE RET. QUINTA -->
            <b-col md="5" v-if="tipo_planilla == 'Form'">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="PercentIcon" size="18" class="mr-50" /> DETALLE RET. QUINTA
                </h6>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> SUELDO ANUAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ sueldo_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> GRATIF. ANUAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ gratificacion_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO EXTRAOR.: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ bono_extraordinario_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SUELDO BRUTO ANUAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ sueldo_bruto_anio | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> MONTO DEDUCIBLE: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ monto_deducible | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BASE NETA: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ base_neta | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> IMPUESTO TOTAL: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ monto_total_impuesto | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TOTAL A DESCONTAR: </b-td>
                        <b-td v-if="sueldo_anio > 0" class="text-danger">
                          S/. {{ descuento_quinta | currencyZero }}
                        </b-td>
                        <b-td v-else class="text-danger"> - </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- DETALLE DESC. APORTES -->
            <b-col md="7" v-if="tipo_planilla == 'Form'">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="ShieldIcon" size="18" class="mr-50" /> DETALLE DESC. APORTES
                </h6>
                <div class="" style="height: 200px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> PORCENTAJE </b-th>
                        <b-th> MONTO </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> PENSION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="">
                          {{ aporte_nombre }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TIPO COMISION: </b-td>
                        <b-td v-if="pension_fund_id != null && tipo_comision" class="">
                          {{ tipo_comision.toUpperCase() }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> CONTRIBUCION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="text-primary">
                          % {{ porcentaje_contribucion }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td v-if="pension_fund_id != null" class="text-danger">
                          S/. {{ monto_contribucion | currencyZero }}
                        </b-td>
                        <b-td v-else>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SEGURO: </b-td>
                        <b-td v-if="pension_fund_id != null" class="text-primary">
                          % {{ porcentaje_seguro }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td v-if="pension_fund_id != null" class="text-danger">
                          S/. {{ monto_seguro | currencyZero }}
                        </b-td>
                        <b-td v-else>-</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> COMISION: </b-td>
                        <b-td v-if="pension_fund_id != null" class="text-primary">
                          % {{ porcentaje_comision }}
                        </b-td>
                        <b-td v-else>-</b-td>

                        <b-td v-if="pension_fund_id != null" class="text-danger">
                          S/. {{ monto_comision | currencyZero }}
                        </b-td>
                        <b-td v-else>-</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- PAGO ADICIONAL -->
            <b-col md="5" v-if="tiene_otro_pago == 1">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="PlusCircleIcon" size="18" class="mr-50" /> PAGO ADICIONAL
                </h6>
                <div class="" style="height: 280px; overflow-y: auto">
                  <b-table-simple hover small striped caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> CONCEPTO </b-th>
                        <b-th> VALOR </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> SUELDO BASE: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_salary | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONIFICACION: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_bonification | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> SUELDO DIARIO: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_salary_per_day | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DOMINICAL: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO QUINCENA: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_bono_quincena | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> PAGO QUINCENA: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_fortnight_amount | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> TRABAJO ADICIONAL: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_trabajo_adicional_monto | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS FALTAS: </b-td>
                        <b-td class="text-danger">
                          S/. {{ or_total_descuento_faltas | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS TARDANZAS: </b-td>
                        <b-td class="text-danger">
                          S/.
                          {{ or_total_descuento_tardanzas | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS DOMINICAL: </b-td>
                        <b-td class="text-danger">
                          S/.
                          {{ or_total_dominical | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS CONCEPTO: </b-td>
                        <b-td class="text-danger">
                          S/. {{ or_total_descuento_otros | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> DESCUENTOS TOTAL: </b-td>
                        <b-td class="text-danger">
                          S/. {{ or_total_descuento | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> BONO FIN DE MES: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_bono_mensual | currencyZero }}
                        </b-td>
                      </b-tr>
                      <b-tr>
                        <b-td> PAGO MES: </b-td>
                        <b-td class="text-primary">
                          S/. {{ or_total_amount | currencyZero }}
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </div>
              </b-card>
            </b-col>

            <!-- DESCUENTOS POR CONCEPTO -->
            <b-col :md="tiene_otro_pago == 1 ? '7' : '12'">
              <b-card class="card-app-design mb-1" body-class="py-1">
                <h6 class="luxury-gradient-text d-flex align-items-center mb-1">
                  <feather-icon icon="MinusCircleIcon" size="18" class="mr-50" /> DESCUENTOS POR CONCEPTO
                </h6>
                <div v-if="payroll.discounts && payroll.discounts.length" class=""
                  style="height: 220px; overflow-y: auto">
                  <b-table-simple hover striped small caption-top responsive class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <b-thead head-variant="light">
                      <b-tr>
                        <b-th> {{ $t("Registered At") }} </b-th>
                        <b-th> {{ $t("Discount Date") }} </b-th>
                        <b-th> {{ $t("Type") }} </b-th>
                        <b-th> {{ $t("Amount") }} </b-th>
                        <b-th> {{ $t("Status") }} </b-th>
                        <b-th> </b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <template v-for="(disc, key) in payroll.discounts">
                        <b-tr :key="key">
                          <b-td> {{ disc.date | globalDate }} </b-td>
                          <b-td> {{ disc.discount_date | globalDate }} </b-td>
                          <b-td> {{ disc.discount_type_name }} </b-td>
                          <b-td>
                            <b-badge variant="light-primary">
                              S/ {{ disc.amount | currency }}
                            </b-badge>
                          </b-td>
                          <b-td>
                            <b-badge :variant="disc.status_fraction == 'Discounted'
                              ? 'light-success'
                              : 'light-warning'
                              ">
                              {{ disc.status_fraction }}
                            </b-badge>
                          </b-td>
                          <b-td>
                            <b-form-checkbox v-model="disc.check" :disabled="disc.status_fraction == 'Discounted' || isView
                              " :value="1" class="custom-control-primary" @change="addDiscountToPayroll(disc)">
                            </b-form-checkbox>
                          </b-td>
                        </b-tr>
                      </template>
                    </b-tbody>
                    <b-tfoot>
                      <b-tr>
                        <b-td colspan="3" class="text-right" style="opacity: 0.7; font-size: 13px">
                          {{ $t("Total Discount") }}:
                        </b-td>
                        <b-td colspan="2" style="opacity: 0.7; font-size: 13px">
                          <b-badge variant="light-danger">
                            S/ {{ getTotalDiscount | currency }}
                          </b-badge>
                        </b-td>
                      </b-tr>
                    </b-tfoot>
                  </b-table-simple>
                </div>
                <div v-else class="text-center w-100">
                  <b-table :fields="discountFields" :items="[]" small show-empty class="position-relative font-small-3"
                    table-class="text-nowrap" sticky-header="50vh">
                    <template #empty>
                      <div class="d-flex justify-content-center align-items-center" style="height: 80px">
                        <span class="text-muted" style="font-size: 16px">No se encontraron descuentos</span>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="beta-approve-view" v-else>
        <div class="beta-hero-stats">
          <div class="beta-stat">
            <div class="label">Periodo</div>
            <div class="value sm">{{ cutOfDate | myGlobal }}</div>
            <div class="sub">{{ department }}</div>
          </div>
          <div class="beta-stat">
            <div class="label">Sueldo base</div>
            <div class="value">S/ {{ basicSalary | currencyZero }}</div>
          </div>
          <div class="beta-stat">
            <div class="label">Total descuentos</div>
            <div class="value danger">S/ {{ totalDescuentosBeta | currencyZero }}</div>
          </div>
          <div class="beta-stat net">
            <div class="label">Neto a pagar</div>
            <div class="value">S/ {{ (isMonthly ? monthlyAmount : fortnightAmount) | currencyZero }}</div>
          </div>
        </div>

        <div class="beta-shell">
          <nav class="beta-nav">
            <a href="#" @click.prevent="scrollToBetaSection('asistencia')">Asistencia</a>
            <a href="#" @click.prevent="scrollToBetaSection('haberes')">Haberes</a>
            <a href="#" @click.prevent="scrollToBetaSection('descuentos')">Descuentos</a>
            <a href="#" v-if="tipo_planilla == 'Form'" @click.prevent="scrollToBetaSection('quinta')">Quinta categoría</a>
            <a href="#" v-if="tipo_planilla == 'Form'" @click.prevent="scrollToBetaSection('aportes')">Aportes</a>
            <a href="#" v-if="tiene_otro_pago == 1" @click.prevent="scrollToBetaSection('adicional')">Pago adicional</a>
            <a href="#" @click.prevent="scrollToBetaSection('conceptos')">Descuentos por concepto</a>
          </nav>

          <div class="beta-content" ref="betaContent">
            <section id="beta-sec-asistencia" class="beta-card">
              <h6><feather-icon icon="CalendarIcon" size="15" class="mr-50" />Asistencia</h6>

              <div class="att-stats">
                <div class="att-stat"><span class="n">{{ totalWorkedDays }}</span><span class="l">trabajados</span></div>
                <div class="att-stat"><span class="n">{{ getAttendances.length - totalWorkedDays }}</span><span class="l">no trabajados</span></div>
                <div class="att-stat"><span class="n">{{ parseInt(cantidad_faltas_quincena || 0) + parseInt(cantidad_faltas_mes || 0) }}</span><span class="l">faltas</span></div>
                <div class="att-stat"><span class="n">{{ parseInt(cantidad_tardanzas || 0) + parseInt(cantidad_tardanzas_mes || 0) }}</span><span class="l">tardanzas</span></div>
              </div>

              <template v-if="calendarInfo.cells.length">
                <div class="cal-grid">
                  <div class="cal-dow" v-for="d in ['L','M','X','J','V','S','D']" :key="d">{{ d }}</div>
                  <div class="cal-cell blank" v-for="n in calendarInfo.leadingBlanks" :key="'b' + n"></div>
                  <div v-for="(c, ci) in calendarInfo.cells" :key="ci" :class="['cal-cell', c.cls]"
                    v-b-tooltip.hover :title="c.date">
                    {{ c.day }}
                    <span v-if="c.late" class="late-dot"></span>
                  </div>
                </div>
                <div class="legend">
                  <span><i class="lg-work"></i>Trabajado</span>
                  <span><i class="lg-absent"></i>Falta</span>
                  <span><i class="lg-justified"></i>Justificado</span>
                  <span><i class="lg-free"></i>Libre</span>
                  <span><i class="lg-late"></i>Tardanza</span>
                </div>
              </template>
              <p v-else class="text-muted small mb-0">Sin registro de asistencias para este periodo.</p>
            </section>

            <section id="beta-sec-haberes" class="beta-card">
              <h6><feather-icon icon="DollarSignIcon" size="15" class="mr-50" />Haberes</h6>
              <div class="calc-line"><span class="k">Sueldo base</span><span class="v">S/ {{ basicSalary | currencyZero }}</span></div>
              <div class="calc-line" v-if="bonification"><span class="k">Bonificación</span><span class="v">S/ {{ bonification | currencyZero }}</span></div>
              <div class="calc-line" v-if="monto_trabajo_adicional"><span class="k">Trabajo adicional</span><span class="v">S/ {{ monto_trabajo_adicional | currencyZero }}</span></div>
              <div class="calc-line" v-if="bono_quincena"><span class="k">Bono 1ra quincena</span><span class="v">S/ {{ bono_quincena | currencyZero }}</span></div>
              <div class="calc-line" v-if="bono_mensual"><span class="k">Bono 2da quincena</span><span class="v">S/ {{ bono_mensual | currencyZero }}</span></div>
              <div class="calc-line" v-if="dominical"><span class="k">Dominical</span><span class="v">S/ {{ dominical | currencyZero }}</span></div>
            </section>

            <section id="beta-sec-descuentos" class="beta-card">
              <h6><feather-icon icon="TrendingDownIcon" size="15" class="mr-50" />Descuentos</h6>
              <div class="calc-line neg" v-if="descuento_falta"><span class="k">Faltas</span><span class="v">− S/ {{ descuento_falta | currencyZero }}</span></div>
              <div class="calc-line neg" v-if="descuento_tardanza"><span class="k">Tardanzas</span><span class="v">− S/ {{ descuento_tardanza | currencyZero }}</span></div>
              <div class="calc-line neg" v-if="total_dominical"><span class="k">Dominical</span><span class="v">− S/ {{ total_dominical | currencyZero }}</span></div>
              <div class="calc-line neg" v-if="tipo_planilla == 'Form' && descuento_aportes"><span class="k">Aportes (AFP/seguro/comisión)</span><span class="v">− S/ {{ descuento_aportes | currencyZero }}</span></div>
              <div class="calc-line neg" v-if="tipo_planilla == 'Form' && descuento_quinta"><span class="k">Retención quinta categoría<span class="tag-mini law">IR 5ta</span></span><span class="v">− S/ {{ descuento_quinta | currencyZero }}</span></div>
              <div class="calc-line neg" v-if="descuento_por_concepto"><span class="k">Por concepto</span><span class="v">− S/ {{ descuento_por_concepto | currencyZero }}</span></div>
              <div class="calc-line total"><span class="k">Total descuentos</span><span class="v total-danger">S/ {{ totalDescuentosBeta | currencyZero }}</span></div>
            </section>

            <section id="beta-sec-quinta" class="beta-card" v-if="tipo_planilla == 'Form' && sueldo_anio > 0">
              <h6><feather-icon icon="PercentIcon" size="15" class="mr-50" />Quinta categoría — detalle de la retención</h6>
              <div class="quinta-substats">
                <div class="qs"><div class="l">Sueldo proyectado</div><div class="v">S/ {{ sueldo_anio | currencyZero }}</div></div>
                <div class="qs"><div class="l">Gratificación anual</div><div class="v">S/ {{ gratificacion_anio | currencyZero }}</div></div>
                <div class="qs"><div class="l">Deducción (7 UIT)</div><div class="v">S/ {{ monto_deducible | currencyZero }}</div></div>
                <div class="qs"><div class="l">Base neta anual</div><div class="v">S/ {{ base_neta | currencyZero }}</div></div>
              </div>

              <table class="tramos-table" v-if="tramosQuinta.length">
                <thead><tr><th>Tramo</th><th>Tasa</th><th class="num">Base gravada</th><th class="num">Impuesto</th></tr></thead>
                <tbody>
                  <tr v-for="(t, ti) in tramosQuinta" :key="ti">
                    <td>{{ t.name }}</td>
                    <td>{{ t.porcentaje }}%</td>
                    <td class="num">S/ {{ t.base_gravada | currencyZero }}</td>
                    <td class="num">S/ {{ t.impuesto | currencyZero }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="calc-line total" style="margin-top:0.6rem">
                <span class="k">Impuesto anual proyectado</span><span class="v">S/ {{ monto_total_impuesto | currencyZero }}</span>
              </div>
              <div class="calc-line"><span class="k">Retención de este periodo</span><span class="v">S/ {{ descuento_quinta | currencyZero }}</span></div>

              <div class="note-inline" v-if="bono_extraordinario_anio">
                La bonificación extraordinaria (Ley 30334) está inafecta al Impuesto a la Renta y no forma parte de la base gravada.
                <span class="tag-mini exempt">Inafecto</span>
              </div>
            </section>

            <section id="beta-sec-aportes" class="beta-card" v-if="tipo_planilla == 'Form' && pension_fund_id != null">
              <h6><feather-icon icon="ShieldIcon" size="15" class="mr-50" />Aportes</h6>
              <div class="calc-line"><span class="k">Pensión<span class="pct">{{ aporte_nombre }}</span></span><span class="v">{{ tipo_comision ? tipo_comision.toUpperCase() : '-' }}</span></div>
              <div class="calc-line neg"><span class="k">Contribución<span class="pct">{{ porcentaje_contribucion }}%</span></span><span class="v">− S/ {{ monto_contribucion | currencyZero }}</span></div>
              <div class="calc-line neg"><span class="k">Seguro<span class="pct">{{ porcentaje_seguro }}%</span></span><span class="v">− S/ {{ monto_seguro | currencyZero }}</span></div>
              <div class="calc-line neg"><span class="k">Comisión<span class="pct">{{ porcentaje_comision }}%</span></span><span class="v">− S/ {{ monto_comision | currencyZero }}</span></div>
            </section>

            <section id="beta-sec-adicional" class="beta-card" v-if="tiene_otro_pago == 1">
              <h6><feather-icon icon="PlusCircleIcon" size="15" class="mr-50" />Pago adicional</h6>
              <div class="calc-line"><span class="k">Sueldo base</span><span class="v">S/ {{ or_salary | currencyZero }}</span></div>
              <div class="calc-line" v-if="or_bonification"><span class="k">Bonificación</span><span class="v">S/ {{ or_bonification | currencyZero }}</span></div>
              <div class="calc-line" v-if="or_trabajo_adicional_monto"><span class="k">Trabajo adicional</span><span class="v">S/ {{ or_trabajo_adicional_monto | currencyZero }}</span></div>
              <div class="calc-line neg" v-if="or_total_descuento"><span class="k">Descuentos</span><span class="v">− S/ {{ or_total_descuento | currencyZero }}</span></div>
              <div class="calc-line total"><span class="k">Pago del mes</span><span class="v">S/ {{ or_total_amount | currencyZero }}</span></div>
            </section>

            <section id="beta-sec-conceptos" class="beta-card">
              <h6><feather-icon icon="MinusCircleIcon" size="15" class="mr-50" />Descuentos por concepto</h6>
              <div class="mini-list" v-if="payroll.discounts && payroll.discounts.length">
                <div class="mini-item" v-for="(disc, key) in payroll.discounts" :key="key">
                  <span class="m-desc">
                    {{ disc.discount_type_name }}
                    <span class="m-meta">{{ disc.discount_date | globalDate }} · {{ disc.status_fraction }}</span>
                  </span>
                  <span class="m-amt">S/ {{ disc.amount | currencyZero }}</span>
                </div>
              </div>
              <p v-else class="text-muted small mb-0">No se encontraron descuentos.</p>
            </section>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <template #modal-footer>
        <div class="text-right">
          <b-button variant="outline-danger" @click="$emit('hideModal')" class="mr-1">
            {{ $t("close").toUpperCase() }}
          </b-button>

          <b-button variant="outline-primary mr-1" @click="recalculatePayroll" v-if="isReadyApprove == 0">
            {{ $t("Recalculate Payroll").toUpperCase() }}
          </b-button>

          <b-button v-if="isReadyApprove == 1 && !isView" variant="outline-primary" @click="approvePayroll">
            {{ $t("Approve").toUpperCase() }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <ModalJustificationAttendance v-if="showModalJustificationAttendance" :personal="justifyData" :datesSelected="[]"
      :mode="modeJustificacion" @hidden="showModalJustificationAttendance = false" @stored="storedEvent" />

    <AddJustificationModal v-if="showAddJustificationModal" :personal="currentPersonal"
      :datesSelected="[currentPersonal.startDate]" @hidden="showAddJustificationModal = false"
      @close="showAddJustificationModal = false" />
    <ShowJustificationModal v-if="showShowJustificationModal" :personal="currentPersonal"
      @hidden="showShowJustificationModal = false" @close="showShowJustificationModal = false" />

    <b-modal hide-footer size="xl" no-close-on-backdrop no-close-on-esc v-model="modalSchedule"
      :title="$t('Employee Schedule')">
      <PersonalSchedule :employeeId="employeeId" :type="'modal'" :onlyView="true" @close="modalSchedule = false" />
    </b-modal>

    <ModalCreateManualAttendance v-if="showCreateManualAttendanceModal" :attendanceData="attendanceSelected"
      @hidden="showCreateManualAttendanceModal = false" @stored="storedEvent" />

    <PlanillaConfirmacionModal v-if="showConfirmacionPlanillaModal" :idPlanillas="idPlanillasToApprove"
      :tipo="'ADMINISTRATIVO'" @close="showConfirmacionPlanillaModal = false"
      @confirmed="handleConfirmacionAprobacionPlanilla" />
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";

import AdministrativePayrollService from "@/views/rrhh/views/payroll/services/administrative-payroll.service.js";
import AddJustificationModal from "@/views/rrhh/views/payroll/components/administrative-payroll/AddJustificationModal.vue";
import ShowJustificationModal from "@/views/rrhh/views/payroll/components/administrative-payroll/ShowJustificationModal.vue";
import PersonalSchedule from "@/views/rrhh/views/employees/components/information/schedule/PersonalSchedule.vue";

import ModalJustificationAttendance from "@/views/commons/employee_attendance/justifications/modals/ModalJustificationAttendance.vue";
import ModalCreateManualAttendance from "@/views/commons/employee_attendance/justifications/modals/ModalCreateManualAttendance.vue";
import PlanillaConfirmacionModal from "@/views/rrhh/views/payroll/components/administrative-payroll/PlanillaConfirmacionModal.vue";

export default {
  components: {
    flatPickr,
    AddJustificationModal,
    ShowJustificationModal,
    PersonalSchedule,
    ModalJustificationAttendance,
    ModalCreateManualAttendance,
    PlanillaConfirmacionModal,
  },
  props: {
    selectedPayroll: {
      type: Object,
      required: true,
    },
    isView: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      showConfirmacionPlanillaModal: false,
      viewMode: "current",
      show: true,
      payroll: {
        attendances: [],
      },
      employeeId: null,
      employeeName: null,
      attendanceId: null,
      attendanceCode: null,
      startDate: null,
      cutOfDate: null,
      basicSalary: 0,
      notRegistered: 0,
      workedDays: 0,
      notWorkedDays: 0,
      salaryPerDay: 0,
      bonification: 0,
      totalDiscount: 0,
      fortnightAmount: 0,
      isReadyApprove: 0,
      isMonthly: false,
      department: "",
      modalSchedule: false,
      start_date_work: null,
      fecha_cese: null,

      tipo_planilla: null,

      cantidad_faltas_quincena: 0,
      cantidad_faltas_mes: 0,
      cantidad_tardanzas_mes: 0,

      cantidad_tardanzas: 0,
      descuento_falta: 0,
      descuento_tardanza: 0,
      descuento_aportes: 0,
      descuento_quinta: 0,
      descuento_por_concepto: 0,

      pension_fund_id: null,
      aporte_nombre: "",
      tipo_comision: "",
      porcentaje_contribucion: 0,
      monto_contribucion: 0,
      porcentaje_seguro: 0,
      monto_seguro: 0,
      porcentaje_comision: 0,
      monto_comision: 0,
      monto_dominical_quincena: 0,

      sueldo_anio: 0,
      gratificacion_anio: 0,
      bono_extraordinario_anio: 0,
      sueldo_bruto_anio: 0,
      monto_deducible: 0,
      base_neta: 0,
      monto_total_impuesto: 0,

      // TRABAJO ADICIONAL
      cantidad_trabajo_adicional: 0,
      monto_trabajo_adicional: 0,

      // Dominical
      dominical: 0,
      descuento_dominical: 0,

      bono_quincena: 0,
      bono_mensual: 0,

      or_bono_quincena: 0,
      or_bono_mensual: 0,

      // PAGO ADICIONAL
      tiene_otro_pago: 0,
      or_type_form: null,
      or_labor_regime_id: null,
      or_salary: 0,
      or_bonification: 0,
      or_salary_per_day: 0,
      or_fortnight_amount: 0,
      or_descuento_x_tardanza: 0,
      or_monthly_descuento_tardanza: 0,
      or_descuento_x_falta: 0,
      or_monthly_descuento_falta: 0,
      or_others_discount: 0,
      or_monthly_others_discount: 0,
      or_total_descuento: 0,
      or_total_amount: 0,
      or_monto_dominical_quincena: 0,

      or_trabajo_adicional_cantidad: 0,
      or_trabajo_adicional_monto: 0,

      or_total_descuento_tardanzas: 0,
      or_total_descuento_faltas: 0,
      or_total_descuento_otros: 0,


      // dominical pago adicional
      or_dominical: 0,
      or_descuento_dominical: 0,
      or_total_dominical: 0,
      total_dominical: 0,

      salary_afecto: 0,
      salario_diario_afecto: 0,

      showModalJustificationAttendance: false,
      justifyData: {},
      modeJustificacion: "single",

      showCreateManualAttendanceModal: false,
      attendanceSelected: {},

      payrollBackup: {},
      currentPersonal: {},
      showAddJustificationModal: false,
      showShowJustificationModal: false,
      discountFields: [
        {
          key: "registered_at",
          label: this.$t("Registered At"),
          sortable: true,
        },
        {
          key: "discount_date",
          label: this.$t("Discount Date"),
          sortable: true,
        },
        {
          key: "discount_type_name",
          label: this.$t("Type"),
          sortable: true,
        },
        {
          key: "amount",
          label: this.$t("Amount"),
          sortable: true,
        },
        {
          key: "status_fraction",
          label: this.$t("Status"),
          sortable: true,
        },
      ],
    };
  },

  async created() {
    await this.getAdministrativePayrollById();
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    getTotalDiscount() {
      let total = 0;
      this.payroll.discounts.map((dis) => {
        total += dis.amount;
      });
      return total;
    },

    getCurrentBrackPoint() {
      return this.$store.getters["app/currentBreakPoint"];
    },

    totalAttendances() {
      let one_hundred_percent = this.payroll.attendances.length;
      let total_worked_days = this.payroll.attendances.filter(
        (item) => item.worked_day == 1
      ).length;
      return ((total_worked_days * 100) / one_hundred_percent).toFixed(2);
    },

    totalDaysToWork() {
      return this.payroll.attendances.length;
    },

    totalWorkedDays() {
      return this.payroll.attendances.filter((item) => item.worked_day == 1)
        .length;
    },

    isFornightly() {
      return this.payroll.payment_method == "fornightly";
    },

    getAttendances() {
      if (this.fecha_cese != null) {
        return this.payroll.attendances.filter((item) =>
          moment(item.date).isSameOrAfter(this.start_date_work) &&
          moment(item.date).isSameOrBefore(moment(this.fecha_cese))
        );
      } else {
        return this.payroll.attendances.filter((item) =>
          moment(item.date).isSameOrAfter(this.start_date_work)
        );
      }
    },

    attendanceBreakdown() {
      if (!this.getAttendances || !this.getAttendances.length) return [];
      
      let breakdown = {};
      this.getAttendances.forEach(att => {
        let name = 'Desconocido';
        let variant = 'light-secondary';

        if (att.new_status == 2) {
          name = 'Día no laborable';
          variant = 'light-info';
        } else if (att.es_vacacion == 1) {
          name = 'Vacaciones';
          variant = 'light-success';
        } else if (att.is_holiday == 1) {
          name = 'Feriado';
          variant = 'light-danger';
        } else {
            if (att.new_status == 6) {
               name = 'Justificado / Permiso';
               variant = 'light-primary';
            } else if (att.new_status == 7) {
               name = 'Justificación Rechazada';
               variant = 'light-danger';
            } else if (att.new_status == 8) {
               name = 'Justificación Pendiente';
               variant = 'light-warning';
            } else if (att.start != null) {
               if (att.is_late == 1) {
                 name = 'Asistencia (Tardanza)';
                 variant = 'light-warning';
               } else {
                 name = 'Asistencia (Puntual)';
                 variant = 'light-success';
               }
            } else if (att.start == null && att.end == null) {
               name = 'Falta (No Marcó)';
               variant = 'light-danger';
            } else {
               name = 'Marcación Incompleta';
               variant = 'light-warning';
            }
        }
        
        if (!breakdown[name]) {
          breakdown[name] = { count: 0, variant: variant };
        }
        breakdown[name].count++;
      });
      
      return Object.entries(breakdown).map(([name, data]) => ({
        name: name,
        count: data.count,
        variant: data.variant
      }));
    },

    idPlanillasToApprove() {
      let planillas = [];

      planillas.push({
        user_id: this.currentUser.id,
        payroll_id: this.selectedPayroll.id,
      });

      return planillas;
    },

    totalDescuentosBeta() {
      return (
        parseFloat(this.descuento_falta || 0) +
        parseFloat(this.descuento_tardanza || 0) +
        parseFloat(this.total_dominical || 0) +
        parseFloat(this.tipo_planilla == "Form" ? this.descuento_aportes || 0 : 0) +
        parseFloat(this.tipo_planilla == "Form" ? this.descuento_quinta || 0 : 0) +
        parseFloat(this.descuento_por_concepto || 0)
      );
    },

    tramosQuinta() {
      const raw = this.payroll ? this.payroll.tramos : null;
      if (!raw) return [];
      try {
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },

    calendarInfo() {
      const attendances = this.getAttendances || [];
      if (!attendances.length) return { cells: [], leadingBlanks: 0 };

      const sorted = [...attendances].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      const firstDate = new Date(sorted[0].date);
      const leadingBlanks = (firstDate.getDay() + 6) % 7; // semana inicia en lunes

      const cells = sorted.map((att) => {
        const info = this.classifyAttendance(att);
        return {
          day: new Date(att.date).getDate(),
          date: moment(att.date).format("dddd DD/MM"),
          cls: info.cls,
          late: info.late,
        };
      });

      return { cells, leadingBlanks };
    },
  },
  methods: {
    async getAdministrativePayrollById() {
      try {
        this.addPreloader();
        const { data } =
          await AdministrativePayrollService.getAdministrativePayrollById({
            id: this.selectedPayroll.id,
          });
        this.employeeName = data[0].name;
        this.startDate = data[0].start_date;
        this.fortnightCutDay = data[0].fornight_cut_day;
        this.cutOfDate = data[0].month;
        this.basicSalary = data[0].salary_per_month;
        this.bonification = data[0].bonification;
        this.payroll = data[0];
        this.workedDays = data[0].worked_days;
        this.notWorkedDays = data[0].not_worked_days;
        this.fortnightAmount = data[0].fortnight_amount;
        this.salaryPerDay = data[0].salary_per_day;
        this.employeeId = data[0].employee_id;
        this.isMonthly = data[0].is_monthly == 1;
        this.isReadyApprove = data[0].is_ready_to_approve;
        this.monthlyAmount = data[0].monthly_amount;
        this.department = data[0].department;
        this.start_date_work = moment(data[0].start_date_work);

        this.tipo_planilla = data[0].type_form;
        this.cantidad_tardanzas = data[0].cantidad_tardanzas;
        this.fecha_cese = data[0].fecha_cese;

        this.cantidad_faltas_quincena = data[0].cantidad_faltas_quincena;
        this.cantidad_faltas_mes = data[0].cantidad_faltas_mes;
        this.cantidad_tardanzas_mes = data[0].cantidad_tardanzas_mes;

        // Resumen de descuentos
        this.descuento_falta =
          parseFloat(data[0].descuento_x_falta) +
          parseFloat(data[0].monthly_descuento_falta);
        this.descuento_tardanza =
          parseFloat(data[0].descuento_x_tardanza) +
          parseFloat(data[0].monthly_descuento_tardanza);
        this.descuento_aportes =
          parseFloat(data[0].monto_contribucion) +
          parseFloat(
            data[0].monto_seguro + parseFloat(data[0].monto_comision)
          ) +
          parseFloat(data[0].monto_contribucion_quincena) +
          parseFloat(data[0].monto_seguro_quincena) +
          parseFloat(data[0].monto_comision_quincena);
        this.descuento_quinta = parseFloat(data[0].monto_quinta);
        this.descuento_por_concepto =
          parseFloat(
            data[0].other_discounts != null ? data[0].other_discounts : 0
          ) + parseFloat(data[0].monthly_others_discount);

        // Detalle de aportes
        this.pension_fund_id = data[0].pension_fund_id;
        this.aporte_nombre = data[0].pension_fund_name;
        this.tipo_comision = data[0].tipo_comision;
        this.porcentaje_contribucion = data[0].porcentaje_contribucion;
        this.monto_contribucion =
          parseFloat(data[0].monto_contribucion) +
          parseFloat(data[0].monto_contribucion_quincena);
        this.porcentaje_seguro = data[0].porcentaje_seguro;
        this.monto_seguro =
          parseFloat(data[0].monto_seguro) +
          parseFloat(data[0].monto_seguro_quincena);
        this.porcentaje_comision =
          data[0].tipo_comision == "mixto"
            ? data[0].porcentaje_comision_mixto
            : data[0].porcentaje_comision;
        this.monto_comision =
          parseFloat(data[0].monto_comision) +
          parseFloat(data[0].monto_comision_quincena);

        this.salary_afecto = data[0].salary_afecto;
        this.salario_diario_afecto = this.salary_afecto / 30;

        // Detalle de impuesto ret. quinta
        this.sueldo_anio = data[0].sueldo_anio;
        this.gratificacion_anio = data[0].gratificacion_anio;
        this.bono_extraordinario_anio = data[0].bono_extraordinario_anio;
        this.sueldo_bruto_anio = data[0].sueldo_bruto_anio;
        this.monto_deducible = data[0].monto_deducible;
        this.base_neta = data[0].base_neta;
        this.monto_total_impuesto = data[0].monto_total_impuesto;

        this.monto_trabajo_adicional = data[0].trabajo_adicional_total;
        this.cantidad_trabajo_adicional = data[0].trabajo_adicional_cantidad;

        this.or_trabajo_adicional_cantidad = data[0].trabajo_adicional_cantidad;
        this.or_trabajo_adicional_monto = data[0].or_trabajo_adicional;

        this.bono_quincena = parseFloat(data[0].bono_quincena);
        this.bono_mensual = parseFloat(data[0].bono_mensual);

        this.or_bono_quincena = parseFloat(data[0].or_bono_quincena);
        this.or_bono_mensual = parseFloat(data[0].or_bono_mensual);

        // Dominical
        this.dominical = data[0].salario_dominical;
        this.descuento_dominical = parseFloat(data[0].monto_dominical_descuento);
        this.monto_dominical_quincena = parseFloat(data[0].monto_dominical_quincena);

        this.total_dominical = this.descuento_dominical + this.monto_dominical_quincena;

        // PAGO ADICIONAL
        this.tiene_otro_pago = data[0].tiene_otro_pago;
        this.or_type_form = data[0].or_type_form;
        this.or_labor_regime_id = data[0].or_labor_regime_id;
        this.or_salary = data[0].or_salary;
        this.or_bonification = data[0].or_bonification;
        this.or_salary_per_day = data[0].or_salary_per_day;
        this.or_fortnight_amount = data[0].or_fortnight_amount;

        // dominical pago adicional
        this.or_dominical = data[0].or_salario_dominical;
        this.or_descuento_dominical = parseFloat(data[0].or_monto_dominical_descuento);
        this.or_monto_dominical_quincena = parseFloat(data[0].or_monto_dominical_quincena);
        this.or_total_dominical = this.or_descuento_dominical + this.or_monto_dominical_quincena;

        this.or_descuento_x_tardanza = parseFloat(
          data[0].or_descuento_x_tardanza
        );
        this.or_monthly_descuento_tardanza = parseFloat(
          data[0].or_monthly_descuento_tardanza
        );
        this.or_descuento_x_falta = parseFloat(data[0].or_descuento_x_falta);
        this.or_monthly_descuento_falta = parseFloat(
          data[0].or_monthly_descuento_falta
        );
        this.or_others_discount = parseFloat(data[0].or_others_discount);
        this.or_monthly_others_discount = parseFloat(
          data[0].or_monthly_others_discount
        );
        this.or_total_descuento = parseFloat(data[0].or_total_descuento);
        this.or_total_amount = parseFloat(data[0].or_total_amount);

        this.or_total_descuento_tardanzas =
          this.or_descuento_x_tardanza + this.or_monthly_descuento_tardanza;
        this.or_total_descuento_faltas =
          this.or_descuento_x_falta + this.or_monthly_descuento_falta;
        this.or_total_descuento_otros =
          this.or_others_discount + this.or_monthly_others_discount;
      } catch (error) {
        this.showToastError(error.response?.data);
      } finally {
        this.removePreloader();
      }
    },

    resolveFieldDay(dateSelect) {
      const fieldDate1 = moment(dateSelect).format("dddd");
      if (fieldDate1 == "miércoles") {
        return "MX";
      }
      const fieldDate = moment(dateSelect).format("dddd")[0].toUpperCase();
      return fieldDate;
    },

    async recalculatePayroll() {
      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();
        const params = {
          end_date: this.cutOfDate,
          payroll_id: this.selectedPayroll.id,
          employee_id: this.employeeId,
          user_id: this.currentUser.id,
          // payment_method: this.payroll.payment_method == "fornightly" ? 1 : 2,
        };
        let data;
        if (this.isMonthly) {
          data = await AdministrativePayrollService.calculateMonthlyPayroll(
            params
          );
        } else {
          data = await AdministrativePayrollService.calculatePayroll(params);
        }
        if (data.data.type === "warning") {
          this.showToastWarning(data.data.msg);
        } else if (data.type === "success") {
          // Aqui consumir api del old soft, para generar caja con el monto
          this.showToastSuccess(data.msg);
        }
        await this.getAdministrativePayrollById();
      } catch (error) {
      } finally {
        this.removePreloader();
      }
    },
    async approvePayroll() {
      this.showConfirmacionPlanillaModal = true;
    },
    handleConfirmacionAprobacionPlanilla() {
      this.$emit("approvePayroll", {
        user_id: this.currentUser.id,
        payroll_id: this.selectedPayroll.id,
      });
    },
    getProgressVariant(value) {
      if (value < 50) {
        return "light-danger";
      } else if (value >= 50 && value < 75) {
        return "light-warning";
      } else if (value >= 75 && value < 100) {
        return "light-info";
      } else {
        return "light-success";
      }
    },
    getProgressClass(value) {
      if (value < 50) {
        return "progress-bar-danger";
      } else if (value >= 50 && value < 75) {
        return "progress-bar-warning";
      } else if (value >= 75 && value < 100) {
        return "progress-bar-info";
      } else {
        return "progress-bar-success";
      }
    },
    getWorkedHoursTooltip(attendance) {
      attendance.worked_hours = attendance.worked_hours.replace(
        "hours",
        this.$t("hours")
      );
      attendance.worked_hours = attendance.worked_hours.replace(
        "and",
        this.$t("and")
      );
      attendance.worked_hours = attendance.worked_hours.replace(
        "minutes",
        this.$t("minutes")
      );
      return `${this.$t("Worked Time")}: ${attendance.worked_hours}`;
    },
    openAddJustificationModal(attendance) {
      this.currentPersonal.personal_id = this.payroll.employee_id;
      this.currentPersonal.startDate = attendance.date;
      this.showAddJustificationModal = true;
    },

    openModalJustificationAttendance(item, mode = "single") {
      this.justifyData = {
        personal_id: this.payroll.employee_id,
        start_date: item.date,
      };
      this.modeJustificacion = mode;
      this.showModalJustificationAttendance = true;
    },

    openCreateManualAttendanceModal(row) {
      this.showCreateManualAttendanceModal = true;
      this.attendanceSelected.date = row.date;
      this.attendanceSelected.personal_id = this.payroll.employee_id;
      this.attendanceSelected.start = row.start;
      this.attendanceSelected.end = row.end;
    },

    openShowJustificationModal(attendance) {
      if (attendance.new_status == 2) return;
      this.currentPersonal.personal_id = this.payroll.employee_id;
      this.currentPersonal.startDate = attendance.date;
      this.showShowJustificationModal = true;
    },

    async storedEvent() {
      this.showModalJustificationAttendance = false;
      // this.selectedAll = false;
      // this.itemsSelected = [];
      // this.getEmployeeJustification();
      this.showCreateManualAttendanceModal = false;
      await this.getAdministrativePayrollById();
      // this.$emit("stored");
    },

    // Pending methods
    async addDiscountToPayroll(discount) {
      if (this.isView) return;
      const check = discount.check;
      const confirm = await this.showConfirmSwal();
      if (confirm.isConfirmed) {
        try {
          this.addPreloader();
          const params = {
            payroll_id: this.selectedPayroll.id,
            discount_fraction_id: discount.fraction_id,
            check,
          };
          const { data } =
            await AdministrativePayrollService.addDiscountToAdministrativePayroll(
              params
            );
          if (data.type == "success") {
            this.showToastSuccess(data.msg);
          }
          this.isReadyApprove = 0;
        } catch (error) {
          this.showToastError();
        } finally {
          this.removePreloader();
        }
      } else {
        if (check) {
          this.$set(discount, "check", 0);
          return;
        }
        this.$set(discount, "check", 1);
      }
    },
    viewSchedule(employeeId) {
      this.modalSchedule = true;
    },

    classifyAttendance(att) {
      if (att.new_status == 2) return { cls: "free", late: false };
      if (att.es_vacacion == 1) return { cls: "free", late: false };
      if (att.is_holiday == 1) return { cls: "free", late: false };
      if (att.new_status == 6) return { cls: "justified", late: false };
      if (att.new_status == 7) return { cls: "absent", late: false };
      if (att.new_status == 8) return { cls: "pending", late: false };
      if (att.start != null) return { cls: "work", late: att.is_late == 1 };
      if (att.start == null && att.end == null)
        return { cls: "absent", late: false };
      return { cls: "pending", late: false };
    },

    scrollToBetaSection(key) {
      const container = this.$refs.betaContent;
      const el = document.getElementById(`beta-sec-${key}`);
      if (container && el) {
        container.scrollTo({
          top: el.offsetTop - container.offsetTop,
          behavior: "smooth",
        });
      } else if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
};
</script>

<style>
.scroll-kanban {
  height: 80vh;
  overflow: scroll;
}

.day-font {
  font-size: 0.8rem !important;
  font-weight: 900 !important;
}

.day {
  height: 100px;
}

.my-badge {
  height: 100px;
  width: 100%;
  white-space: normal;
}

.py-05 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.font-weight-bold {
  font-weight: 900 !important;
  color: #fff !important;
}

.py10 {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

/* Premium Styling Upgrades for Web Application Development Rule 2 & 3 */
::v-deep .card-app-design {
  border-radius: 12px;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(115, 103, 240, 0.08) !important;
  transition: all 0.3s ease-in-out;
  margin-bottom: 1.5rem !important;
}

::v-deep .card-app-design:hover {
  box-shadow: 0 8px 25px 0 rgba(115, 103, 240, 0.1) !important;
  transform: translateY(-2px);
}

::v-deep .card-app-design .luxury-gradient-text {
  background: linear-gradient(90deg, #7367f0, #ce9ffc);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem !important;
  margin-top: 0.8rem !important;
  margin-left: 0.5rem !important;
  display: inline-block;
}

/* Improve tables */
::v-deep .card-app-design .b-table-simple {
  border-spacing: 0 6px !important;
  border-collapse: separate !important;
}

::v-deep .card-app-design .table-striped tbody tr:nth-of-type(odd),
::v-deep .card-app-design .table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(115, 103, 240, 0.03) !important;
}

::v-deep .card-app-design tbody tr {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
  border-radius: 6px;
  transition: all 0.2s ease;
}

::v-deep .card-app-design tbody tr:hover {
  transform: translateX(4px) scale(1.005);
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.06) !important;
  background-color: rgba(115, 103, 240, 0.06) !important;
}

::v-deep .card-app-design td {
  padding: 0.6rem 1rem !important;
  vertical-align: middle;
  border-top: none !important;
  border-bottom: none !important;
}

::v-deep .card-app-design td:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  font-weight: 600;
  color: #6e6b7b;
}

::v-deep .card-app-design td:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

::v-deep .card-app-design td.text-primary,
::v-deep .card-app-design td.text-danger {
  text-align: right;
  font-weight: 700;
}

::v-deep .card-app-design th {
  border: none !important;
  color: #b9b9c3;
  font-size: 0.75rem;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* Kanban badge improvements */
::v-deep .my-badge {
  background: rgba(115, 103, 240, 0.02) !important;
  border: 1px solid rgba(115, 103, 240, 0.08) !important;
  box-shadow: 0 4px 8px rgba(0,0,0,0.02) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

::v-deep .my-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(115,103,240,0.1) !important;
  border-color: rgba(115,103,240,0.2) !important;
}

/* Explicit Dark Mode Overrides for Vuexy */
.dark-layout ::v-deep .card-app-design .table-striped tbody tr:nth-of-type(odd),
.dark-layout ::v-deep .card-app-design .table-striped tbody tr:nth-of-type(even) {
  background-color: rgba(255, 255, 255, 0.02) !important;
}
.dark-layout ::v-deep .card-app-design tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
}
.dark-layout ::v-deep .my-badge {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
}
.dark-layout ::v-deep .card-app-design td:first-child {
  color: #b4b7bd;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background: rgba(115,103,240,0.3);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(115,103,240,0.6);
}

/* ---- view toggle ---- */
.view-toggle-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 0 0.5rem 0.9rem;
  margin: 0 0.5rem 0.5rem;
  border-bottom: 1px solid #e9ecef;
}
.view-toggle-bar .toggle-info { display: flex; flex-direction: column; }
.view-toggle-bar .toggle-title { font-size: 0.85rem; font-weight: 650; color: #212529; }
.view-toggle-bar .toggle-hint { font-size: 0.74rem; color: #8890a8; }
.view-toggle-bar .segmented-control { display: flex; background: #f1f3f9; border-radius: 999px; padding: 3px; gap: 2px; }
.view-toggle-bar .seg-btn {
  border: none;
  background: transparent;
  color: #5b6480;
  font-size: 0.79rem;
  font-weight: 650;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}
.view-toggle-bar .seg-btn.active { background: #ffffff; color: #7367f0; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08); }
.view-toggle-bar .beta-pill {
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  background: #7a4fd1;
  color: #fff;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
}
.dark-layout .view-toggle-bar { border-bottom: 1px solid #3b3b4f; }
.dark-layout .view-toggle-bar .toggle-title { color: #e0e0e0; }
.dark-layout .view-toggle-bar .segmented-control { background: #2a2a3d; }
.dark-layout .view-toggle-bar .seg-btn { color: #aab0c0; }
.dark-layout .view-toggle-bar .seg-btn.active { background: #1e1e2d; color: #a8bdff; }

/* ---- beta approve view ---- */
.beta-approve-view { padding: 0 1.5rem 1rem; }

.beta-hero-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: #eaeef7;
  border: 1px solid #eaeef7;
  border-radius: 0.75rem;
  overflow: hidden;
  margin-bottom: 1rem;
}
.beta-hero-stats .beta-stat { background: #f6f8fc; padding: 0.7rem 1rem; }
.beta-hero-stats .label { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; color: #8890a8; margin-bottom: 0.2rem; }
.beta-hero-stats .value { font-size: 1.02rem; font-weight: 700; color: #212529; }
.beta-hero-stats .value.sm { font-size: 0.82rem; }
.beta-hero-stats .value.danger { color: #b8352f; }
.beta-hero-stats .sub { font-size: 0.68rem; color: #8890a8; margin-top: 0.1rem; }
.beta-hero-stats .beta-stat.net .value { color: #17825a; font-size: 1.15rem; }

.beta-shell { display: flex; border: 1px solid #eaeef7; border-radius: 0.75rem; overflow: hidden; }
.beta-nav {
  width: 165px;
  flex-shrink: 0;
  border-right: 1px solid #eaeef7;
  padding: 0.9rem 0.6rem;
  background: #fbfbfd;
}
.beta-nav a {
  display: block;
  text-decoration: none;
  color: #5b6480;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.45rem 0.5rem;
  border-radius: 0.4rem;
  margin-bottom: 0.1rem;
}
.beta-nav a:hover { background: #eef2fa; color: #212529; }

.beta-content { flex: 1; min-width: 0; padding: 1rem 1.25rem; max-height: 55vh; overflow-y: auto; }

.beta-card { padding: 0 0 1rem; margin-bottom: 1rem; border-bottom: 1px solid #eaeef7; scroll-margin-top: 0.5rem; }
.beta-card:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
.beta-card h6 { font-size: 0.85rem; font-weight: 700; color: #212529; margin-bottom: 0.7rem; display: flex; align-items: center; }

.att-stats { display: flex; gap: 1.1rem; flex-wrap: wrap; margin-bottom: 0.8rem; }
.att-stats .att-stat { display: flex; align-items: baseline; gap: 0.3rem; }
.att-stats .n { font-size: 0.95rem; font-weight: 700; }
.att-stats .l { font-size: 0.7rem; color: #8890a8; }

.cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 3px; margin-bottom: 0.55rem; max-width: 260px; }
.cal-dow { font-size: 0.55rem; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase; color: #8890a8; text-align: center; padding-bottom: 0.15rem; }
.cal-cell {
  aspect-ratio: 1;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  font-weight: 650;
  position: relative;
  background: #eef2fa;
  color: #8890a8;
}
.cal-cell.blank { background: transparent; }
.cal-cell.work { background: #e8edfc; color: #253fa0; }
.cal-cell.free { background: #eef2fa; color: #8890a8; }
.cal-cell.absent { background: #fbeae9; color: #b8352f; }
.cal-cell.justified { background: #efe8fb; color: #7a4fd1; }
.cal-cell.pending { background: #fbf1dd; color: #a4680f; }
.cal-cell .late-dot { position: absolute; top: 2px; right: 2px; width: 4px; height: 4px; border-radius: 50%; background: #a4680f; }

.legend { display: flex; flex-wrap: wrap; gap: 0.7rem; font-size: 0.68rem; color: #5b6480; }
.legend span { display: inline-flex; align-items: center; gap: 0.3rem; }
.legend i { width: 8px; height: 8px; border-radius: 3px; display: inline-block; }
.legend .lg-work { background: #e8edfc; }
.legend .lg-absent { background: #fbeae9; }
.legend .lg-justified { background: #efe8fb; }
.legend .lg-free { background: #eef2fa; }
.legend .lg-late { background: #a4680f; border-radius: 50%; }

.beta-card .calc-line {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.7rem;
  font-size: 0.82rem;
  padding: 0.38rem 0;
  border-bottom: 1px dashed #eaeef7;
}
.beta-card .calc-line:last-of-type { border-bottom: none; }
.beta-card .calc-line .k { color: #5b6480; }
.beta-card .calc-line .k .pct { color: #8890a8; font-size: 0.72rem; margin-left: 0.3rem; }
.beta-card .calc-line .v { font-weight: 600; color: #212529; }
.beta-card .calc-line.neg .v { color: #b8352f; }
.beta-card .calc-line.total { border-top: 1px solid #dfe4f0; margin-top: 0.3rem; padding-top: 0.55rem; }
.beta-card .calc-line.total .k { color: #212529; font-weight: 650; }
.beta-card .calc-line.total .v { font-weight: 750; font-size: 0.9rem; }
.beta-card .calc-line.total .v.total-danger { color: #b8352f; }

.tag-mini {
  display: inline-block;
  font-size: 0.6rem;
  font-weight: 700;
  padding: 0.05rem 0.4rem;
  border-radius: 5px;
  margin-left: 0.35rem;
  vertical-align: middle;
}
.tag-mini.law { background: #e8edfc; color: #253fa0; }
.tag-mini.exempt { background: #e4f6ee; color: #17825a; }

.note-inline {
  margin-top: 0.65rem;
  font-size: 0.74rem;
  color: #5b6480;
  line-height: 1.5;
  background: #f6f8fc;
  border-radius: 0.5rem;
  padding: 0.55rem 0.65rem;
  border-left: 3px solid #7367f0;
}

.quinta-substats { display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.6rem; margin-bottom: 0.9rem; }
.quinta-substats .qs { background: #f6f8fc; border-radius: 0.5rem; padding: 0.55rem 0.65rem; }
.quinta-substats .qs .l { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase; color: #8890a8; margin-bottom: 0.2rem; }
.quinta-substats .qs .v { font-size: 0.85rem; font-weight: 700; }

table.tramos-table { width: 100%; border-collapse: collapse; font-size: 0.77rem; }
table.tramos-table th { text-align: left; font-size: 0.62rem; letter-spacing: 0.04em; text-transform: uppercase; color: #8890a8; font-weight: 700; padding: 0 0.5rem 0.35rem 0; border-bottom: 1px solid #dfe4f0; }
table.tramos-table td { padding: 0.45rem 0.5rem 0.45rem 0; border-bottom: 1px solid #eaeef7; }
table.tramos-table tr:last-child td { border-bottom: none; }
table.tramos-table .num { text-align: right; white-space: nowrap; }

.beta-card .mini-list .mini-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.4rem 0;
  font-size: 0.8rem;
  border-bottom: 1px dashed #eaeef7;
}
.beta-card .mini-list .mini-item:last-child { border-bottom: none; }
.beta-card .mini-list .m-desc { color: #212529; }
.beta-card .mini-list .m-meta { color: #8890a8; font-size: 0.7rem; display: block; margin-top: 0.1rem; }
.beta-card .mini-list .m-amt { font-weight: 650; white-space: nowrap; }

.dark-layout .beta-hero-stats,
.dark-layout .beta-shell { border-color: #3b3b4f; background: #3b3b4f; }
.dark-layout .beta-hero-stats .beta-stat,
.dark-layout .beta-nav,
.dark-layout .beta-content { background: #25293c; }
.dark-layout .beta-hero-stats .value,
.dark-layout .beta-card h6,
.dark-layout .beta-card .calc-line .v,
.dark-layout .beta-card .mini-list .m-desc { color: #e0e0e0; }
.dark-layout .beta-nav { border-right: 1px solid #3b3b4f; }
.dark-layout .beta-nav a { color: #aab0c0; }
.dark-layout .beta-nav a:hover { background: #33384f; color: #e0e0e0; }
.dark-layout .beta-card { border-bottom: 1px solid #3b3b4f; }
.dark-layout .beta-card .calc-line { border-bottom: 1px dashed #3b3b4f; }
.dark-layout .beta-card .calc-line.total { border-top: 1px solid #3b3b4f; }
.dark-layout .note-inline { background: #33384f; color: #aab0c0; }
.dark-layout .quinta-substats .qs { background: #33384f; }
.dark-layout table.tramos-table td,
.dark-layout table.tramos-table th { border-color: #3b3b4f; color: #e0e0e0; }
.dark-layout .cal-cell { background: #33384f; color: #aab0c0; }
</style>